/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProfileOptionDto } from './ProfileOptionDto';
import {
    ProfileOptionDtoFromJSON,
    ProfileOptionDtoFromJSONTyped,
    ProfileOptionDtoToJSON,
    ProfileOptionDtoToJSONTyped,
} from './ProfileOptionDto';
import type { FrameworkOptionDto } from './FrameworkOptionDto';
import {
    FrameworkOptionDtoFromJSON,
    FrameworkOptionDtoFromJSONTyped,
    FrameworkOptionDtoToJSON,
    FrameworkOptionDtoToJSONTyped,
} from './FrameworkOptionDto';

/**
 * 
 * @export
 * @interface ProgramDashboardOptionsDto
 */
export interface ProgramDashboardOptionsDto {
    /**
     * 
     * @type {Array<ProfileOptionDto>}
     * @memberof ProgramDashboardOptionsDto
     */
    profiles?: Array<ProfileOptionDto>;
    /**
     * 
     * @type {Array<FrameworkOptionDto>}
     * @memberof ProgramDashboardOptionsDto
     */
    frameworks?: Array<FrameworkOptionDto>;
}

/**
 * Check if a given object implements the ProgramDashboardOptionsDto interface.
 */
export function instanceOfProgramDashboardOptionsDto(value: object): value is ProgramDashboardOptionsDto {
    return true;
}

export function ProgramDashboardOptionsDtoFromJSON(json: any): ProgramDashboardOptionsDto {
    return ProgramDashboardOptionsDtoFromJSONTyped(json, false);
}

export function ProgramDashboardOptionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramDashboardOptionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'profiles': json['profiles'] == null ? undefined : ((json['profiles'] as Array<any>).map(ProfileOptionDtoFromJSON)),
        'frameworks': json['frameworks'] == null ? undefined : ((json['frameworks'] as Array<any>).map(FrameworkOptionDtoFromJSON)),
    };
}

export function ProgramDashboardOptionsDtoToJSON(json: any): ProgramDashboardOptionsDto {
    return ProgramDashboardOptionsDtoToJSONTyped(json, false);
}

export function ProgramDashboardOptionsDtoToJSONTyped(value?: ProgramDashboardOptionsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'profiles': value['profiles'] == null ? undefined : ((value['profiles'] as Array<any>).map(ProfileOptionDtoToJSON)),
        'frameworks': value['frameworks'] == null ? undefined : ((value['frameworks'] as Array<any>).map(FrameworkOptionDtoToJSON)),
    };
}

